import { render, staticRenderFns } from "./NicheArea.vue?vue&type=template&id=7dfcbcee&scoped=true"
import script from "./NicheArea.vue?vue&type=script&lang=js"
export * from "./NicheArea.vue?vue&type=script&lang=js"
import style0 from "./NicheArea.vue?vue&type=style&index=0&id=7dfcbcee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfcbcee",
  null
  
)

export default component.exports